import { Component, Input } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-application-steps',
  templateUrl: './application-steps.component.html',
  styleUrls: ['./application-steps.component.scss'],
})
export class ApplicationStepsComponent {
  @Input() currentStep: number;
  @Input() isDetailsView: boolean;
  @Input() showTechnicalFormFirst: boolean;

  constructor(public router: Router, private route: ActivatedRoute) {}

  navigate(target: string) {
    const module = this.route.snapshot.data.module;
    const applicationId = Number(this.route.snapshot.paramMap.get('id'));

    this.router.navigate([module, target, applicationId]);
  }
}
